/* Optional sibling-product colours. Ordinary Dawn variant events are not replaced. */
(() => {
  if (window.saylessLinkedColoursReady) return;
  window.saylessLinkedColoursReady = true;
  let activeRequest = null;

  const dataFor = (root) => {
    try {
      return JSON.parse(
        root.querySelector("[data-sl-colour-product-data]")?.textContent ||
          "null",
      );
    } catch {
      return null;
    }
  };
  const status = (root, message) => {
    let node = root.querySelector("[data-sl-colour-status]");
    if (!node && message) {
      node = document.createElement("p");
      node.className = "sl-linked-colours__status";
      node.setAttribute("data-sl-colour-status", "");
      node.setAttribute("role", "status");
      (root.querySelector("variant-selects") || root).append(node);
    }
    if (node) node.textContent = message;
  };
  const selectedSize = (root) => {
    const data = dataFor(root);
    if (
      !data ||
      data.sizeIndex < 0 ||
      root.hasAttribute("data-sl-size-required")
    )
      return null;
    try {
      const selected = JSON.parse(
        root.querySelector("[data-selected-variant]")?.textContent || "null",
      );
      if (selected?.options) return selected.options[data.sizeIndex];
    } catch {
      /* Use current form variant ID below. */
    }
    const id =
      root.querySelector('form[data-type="add-to-cart-form"] [name="id"]')
        ?.value || data.selected;
    return (
      data.variants.find((variant) => String(variant.id) === String(id))
        ?.options[data.sizeIndex] || null
    );
  };
  const readPage = async (url, signal, expectedId) => {
    const response = await fetch(url, {
      signal,
      credentials: "same-origin",
      headers: { Accept: "text/html" },
    });
    if (!response.ok) throw new Error("Product could not be loaded.");
    const html = new DOMParser().parseFromString(
      await response.text(),
      "text/html",
    );
    const root = html.querySelector('main product-info[id^="MainProduct"]');
    const data = root && dataFor(root);
    if (
      !root ||
      !data ||
      String(data.id) !== String(expectedId) ||
      !html.querySelector("head title")
    ) {
      throw new Error(
        "Product page is unavailable or uses a different template.",
      );
    }
    return { html, root, data };
  };
  const requireSize = (root) => {
    root.setAttribute("data-sl-size-required", "");
    // Products may intentionally have no linked-colour metafield. Locate their
    // existing Size control without altering the fallback picker markup.
    if (!root.querySelector("[data-sl-size-controls]")) {
      root
        .querySelectorAll(
          "variant-selects fieldset, variant-selects .product-form__input--dropdown",
        )
        .forEach((group) => {
          const label = group
            .querySelector("legend > span, label")
            ?.textContent.trim()
            .toLowerCase();
          if (label === "size") group.setAttribute("data-sl-size-controls", "");
        });
    }
    root
      .querySelectorAll('[data-sl-size-controls] input[type="radio"]')
      .forEach((input) => {
        input.checked = false;
      });
    root
      .querySelectorAll("[data-sl-size-controls] select")
      .forEach((select) => {
        select.selectedIndex = -1;
      });
    root.productForm?.toggleSubmitButton(true, "Choose a size");
    root
      .querySelectorAll(
        "[data-sayless-buy-now], .shopify-payment-button button",
      )
      .forEach((button) => {
        button.disabled = true;
      });
    status(root, "Please choose an available size for this colour.");
  };
  // A real page load lets Shopify app blocks and embeds initialise for the new product.
  // Carry the unavailable-size gate across that load in this tab only.
  const sizeGateKey = "sayless:linked-colour-size-required";
  const restoreSizeGate = () => {
    let pending;
    try {
      pending = JSON.parse(sessionStorage.getItem(sizeGateKey) || "null");
      sessionStorage.removeItem(sizeGateKey);
    } catch {
      return;
    }
    const root = document.querySelector('main product-info[id^="MainProduct"]');
    if (
      root &&
      pending &&
      pending.productId === root.dataset.productId &&
      pending.expires > Date.now()
    ) {
      requireSize(root);
    }
  };
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", restoreSizeGate, {
      once: true,
    });
  else restoreSizeGate();
  // Guard both normal add-to-cart submission and the existing delegated custom Buy Now.
  const preventUnselectedPurchase = (event) => {
    const root = event.target.closest("product-info[data-sl-size-required]");
    if (!root) return;
    if (
      event.type === "submit" ||
      event.target.closest(
        '[data-sayless-buy-now], [name="add"], .shopify-payment-button',
      )
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
      status(root, "Please choose an available size for this colour.");
      root
        .querySelector(
          "[data-sl-size-controls] input, [data-sl-size-controls] select",
        )
        ?.focus({ preventScroll: true });
    }
  };
  document.addEventListener("submit", preventUnselectedPurchase, true);
  document.addEventListener("click", preventUnselectedPurchase, true);

  // Unlock only after Dawn has received a valid available variant, not on the initial click.
  const connectVariantSubscription = () => {
    if (
      typeof subscribe !== "function" ||
      typeof PUB_SUB_EVENTS === "undefined"
    )
      return;
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      document
        .querySelectorAll("product-info[data-sl-size-required]")
        .forEach((root) => {
          if (
            root.dataset.section !== data.sectionId ||
            !data.variant?.available
          )
            return;
          root.removeAttribute("data-sl-size-required");
          status(root, "");
          root.querySelectorAll("[data-sayless-buy-now]").forEach((button) => {
            button.disabled = false;
          });
          window.Shopify?.PaymentButton?.init();
        });
    });
  };
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", connectVariantSubscription, {
      once: true,
    });
  else connectVariantSubscription();

  document.addEventListener("click", async (event) => {
    const link = event.target.closest("a[data-sl-colour-link]");
    if (
      !link ||
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    )
      return;
    const root = link.closest("product-info");
    // Leave normal links functional outside the full product-page context.
    if (!root || root.dataset.updateUrl !== "true") return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return;
    event.preventDefault();
    if (link.getAttribute("aria-current") === "true" || activeRequest) return;

    const controller = new AbortController();
    activeRequest = controller;
    const timeout = setTimeout(() => controller.abort(), 15000);
    const size = selectedSize(root);
    let committed = false;
    root.abortController?.abort(); // Prevent an older Dawn size response from winning this swap.
    root.pendingRequestUrl = null;
    root.inert = true;
    status(root, "");
    try {
      url.search = "";
      let page = await readPage(
        url.href,
        controller.signal,
        link.dataset.slProductId,
      );
      let needsSize = false;
      if (size && page.data.sizeIndex >= 0) {
        const match = page.data.variants.find(
          (variant) =>
            variant.available && variant.options[page.data.sizeIndex] === size,
        );
        if (match) {
          if (String(page.data.selected) !== String(match.id)) {
            url.searchParams.set("variant", match.id);
            page = await readPage(
              url.href,
              controller.signal,
              link.dataset.slProductId,
            );
            if (String(page.data.selected) !== String(match.id))
              throw new Error("The selected size could not be loaded.");
          }
        } else needsSize = true;
      } else if (
        page.data.sizeIndex >= 0 &&
        root.hasAttribute("data-sl-size-required")
      )
        needsSize = true;
      if (controller.signal.aborted || !root.isConnected) return;
      try {
        if (needsSize) {
          sessionStorage.setItem(
            sizeGateKey,
            JSON.stringify({
              productId: String(page.data.id),
              expires: Date.now() + 60000,
            }),
          );
        } else sessionStorage.removeItem(sizeGateKey);
      } catch {
        /* Navigation still works if session storage is unavailable. */
      }
      window.location.assign(url.href);
      committed = true;
    } catch (error) {
      if (!committed)
        status(root, "Could not load this colour. Please try again.");
      console.error("Sayless colour switch:", error);
    } finally {
      clearTimeout(timeout);
      activeRequest = null;
      root.inert = false;
      if (!committed && root.isConnected) link.focus({ preventScroll: true });
    }
  });

  // Mobile purchase bar follows the real product form and leaves before the footer.
  let mobileBarFrame = 0;
  const mobileRoot = () =>
    document.querySelector('main product-info[id^="MainProduct"]');
  const sizeControls = (root) => {
    const linked = root.querySelector("[data-sl-size-controls]");
    if (linked) return linked;
    return [
      ...root.querySelectorAll(
        "variant-selects fieldset, variant-selects .product-form__input--dropdown",
      ),
    ].find(
      (group) =>
        (
          group.querySelector("legend > span") ||
          group.querySelector("legend, label")
        )?.textContent
          .trim()
          .toLowerCase() === "size",
    );
  };
  const chosenSize = (root, controls) => {
    if (!controls || root.hasAttribute("data-sl-size-required")) return "";
    const selected = controls.querySelector(
      'input[type="radio"]:checked, select',
    );
    if (
      !selected ||
      (selected.tagName === "SELECT" && selected.selectedIndex < 0)
    )
      return "";
    return selected.value || "";
  };
  const updateMobileBar = () => {
    mobileBarFrame = 0;
    const root = mobileRoot();
    const bar = root?.querySelector("[data-sl-mobile-atc]");
    if (!bar) return;
    const source = root.querySelector("product-form .product-form__buttons");
    const nativeButton = source?.querySelector('[name="add"]');
    const footer = document.querySelector("footer");
    const drawerOpen = document.querySelector(
      "cart-drawer.active, cart-drawer[open], .cart-drawer.active",
    );
    const visible =
      window.matchMedia("(max-width: 749px)").matches &&
      source &&
      nativeButton &&
      source.getBoundingClientRect().bottom <= 0 &&
      (!footer || footer.getBoundingClientRect().top > window.innerHeight) &&
      !drawerOpen;
    bar.hidden = !visible;
    if (!visible) return;

    const controls = sizeControls(root);
    const size = chosenSize(root, controls);
    const price =
      source.dataset.saylessCurrentPrice ||
      root
        .querySelector('[id^="price-"] .price-item--regular')
        ?.textContent.trim() ||
      "";
    const sizeText = bar.querySelector("[data-sl-mobile-atc-size]");
    const priceText = bar.querySelector("[data-sl-mobile-atc-price]");
    const button = bar.querySelector("[data-sl-mobile-atc-button]");
    if (sizeText)
      sizeText.textContent = size || (controls ? "Select a size" : "");
    if (priceText && price) priceText.textContent = price;
    if (button) {
      button.textContent =
        controls && !size
          ? "Choose size"
          : nativeButton.disabled
            ? "Sold out"
            : "Add to bag";
      button.disabled = size || !controls ? nativeButton.disabled : false;
    }
  };
  const queueMobileBar = () => {
    if (!mobileBarFrame)
      mobileBarFrame = requestAnimationFrame(updateMobileBar);
  };
  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-sl-mobile-atc-button]");
    if (!button) return;
    const root = button.closest("product-info");
    const controls = root && sizeControls(root);
    if (controls && !chosenSize(root, controls)) {
      controls.scrollIntoView({ behavior: "smooth", block: "center" });
      controls.setAttribute("tabindex", "-1");
      controls.focus({ preventScroll: true });
      return;
    }
    root?.querySelector('product-form [name="add"]')?.click();
    queueMobileBar();
  });
  document.addEventListener("change", () => {
    queueMobileBar();
    setTimeout(queueMobileBar, 100);
  });
  document.addEventListener("product-info:loaded", queueMobileBar);
  document.addEventListener("sayless:product-swapped", queueMobileBar);
  window.addEventListener("scroll", queueMobileBar, { passive: true });
  window.addEventListener("resize", queueMobileBar, { passive: true });
  if (
    typeof subscribe === "function" &&
    typeof PUB_SUB_EVENTS !== "undefined"
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      queueMobileBar();
      setTimeout(queueMobileBar, 100);
    });
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", queueMobileBar, {
      once: true,
    });
  else queueMobileBar();
})();
